'use client';

import { ConsentGate } from '@hc-frontend/features-data-consent';
import Script from 'next/script';

function HubSpotPixelInternal() {
  return (
    <Script
      id="hs-script-loader"
      strategy="lazyOnload"
      src="https://js.hs-scripts.com/49022532.js"
    />
  );
}

/**
 * HubSpot tracking pixel
 * Gated by consent - only loads if user accepts all cookies
 */
export function HubSpotPixel() {
  return (
    <ConsentGate>
      <HubSpotPixelInternal />
    </ConsentGate>
  );
}
